import { ErrorCode } from '@approvalmax/types';
import { useGetKyc } from 'shared/data/walletsKyc/v1';
import { useCompanyIdBasedOnUrl } from 'shared/hooks/useCompanyIdBasedOnUrl';

export const useKycData = () => {
    const { companyId } = useCompanyIdBasedOnUrl();
    const { data, isLoading } = useGetKyc(
        { path: { organizationId: companyId } },
        { cacheTime: 5 * 1000, staleTime: 5 * 1000 },
        { skipToastForErrorCodes: [ErrorCode.FormNotFound] }
    );

    return { data, isLoading };
};
